// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface BulletIconSignature {
  Element: SVGSVGElement;
}

export const BulletIcon: TOC<BulletIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<circle cx="12" cy="12" r="3"/>
</svg>
</template>;